export default "__VITE_ASSET__DbA0u4vh__"